import React from "react";
import { useTranslation } from "react-i18next";

export default function Vignettes() {
  const { t } = useTranslation();

  return (
    <div className="min-h-[70vh] flex flex-col justify-center gap-8 py-12 text-slate-800">
      <section className="max-w-2xl space-y-4">
        <p className="text-sm uppercase tracking-[0.2em] text-slate-400">
          {t("vignettes.badge", "In progress")}
        </p>
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight leading-tight text-slate-900">
          {t("vignettes.title", "Table vignettes & place cards")}
        </h2>
        <p className="text-base md:text-lg text-slate-600 max-w-xl">
          {t(
            "vignettes.inProgress",
            "We are working on this section. Soon you will be able to generate simple, elegant table vignettes for your guests.",
          )}
        </p>
      </section>
    </div>
  );
}
